import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { t } from 'translation'
import { ReactComponent as GoogleBtnIcon } from '../../assets/logos/google.svg'
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth'

import { socialSignIn } from 'store/actions'

const GoogleLoginButton = ({ socialSignIn, disabled }) => {
  return (
    <button
      className="btn_google"
      onClick={(e) => (
        e.preventDefault(), socialSignIn(CognitoHostedUIIdentityProvider.Google)
      )}
      disabled={disabled}
    >
      <GoogleBtnIcon className="btn_google_icon" alt={t('auth.SIGN_IN_WITH_GOOGLE')} />
      <span>{t('auth.SIGN_IN_WITH_GOOGLE')}</span>
    </button>
  )
}

const willMapDispatchToProps = { socialSignIn }

export default connect(null, willMapDispatchToProps)(GoogleLoginButton)

GoogleLoginButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
}
